import i18n from "../i18n";

let messageApi = null;
let notificationApi = null;

const NOTIFICATION_PLACEMENT = "topRight";

export const setMessageApi = (api) => {
  messageApi = api;
};

export const setNotificationApi = (api) => {
  notificationApi = api;
};

export const showNotification = (
  type,
  msg,
  description = "",
  options = {},
) => {
  const notificationType = ["success", "error", "warning", "info"].includes(
    type,
  )
    ? type
    : "info";
  const fallbackMessage =
    notificationType === "error"
      ? i18n.t("something_went_wrong")
      : i18n.t("success");
  const notificationMessage = msg || fallbackMessage;

  if (notificationApi?.[notificationType]) {
    notificationApi[notificationType]({
      ...options,
      message: notificationMessage,
      description: description || undefined,
      placement: NOTIFICATION_PLACEMENT,
    });
    return;
  }

  if (messageApi?.[notificationType]) {
    messageApi[notificationType](
      description
        ? `${notificationMessage}: ${description}`
        : notificationMessage,
    );
    return;
  }

  const consoleMethod = notificationType === "error" ? "error" : "log";
  console[consoleMethod](notificationMessage, description);
};

export const showSuccessMessage = (msg) => {
  showNotification("success", msg || i18n.t("success"));
};

export const showErrorMessage = (msg) => {
  showNotification("error", msg || i18n.t("something_went_wrong"));
};

export const showWarningMessage = (msg, options = {}) => {
  showNotification("warning", msg, "", options);
};
